import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NeoUtilService, MessageService } from '@bcone/neo-app-sdk';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  title = 'app';
  url: string;

  showSideBar = true;
  showNav = true;
  link: any;

  constructor(
    public router: Router,
    private messageService: MessageService,
    private neoUtilService: NeoUtilService
  ) {

    const envData = this.messageService.getEnv();
    for (const key in envData) {
      if (envData[key]) {
        environment[key] = envData[key];
      }
    }
    router.events.subscribe((event) => {
      this.url = router.url;
    });

    if (window.location.hostname === 'localhost' && envData) {

      this.link = envData.graphql_url.replace('graphql', 'apps');
      this.link = this.link.slice(0, -1);
    } else {
      let host = window.location.hostname;
      host = host.substr(host.indexOf('.'), host.length - host.indexOf('.'));
      this.link = `https://apps${host}`;
    }
  }
  ngOnInit() {
    this.checkFragmentUrl();
  }

  checkFragmentUrl() {
    const fragmentUrl = window.location.hash.substr(1);
    if (fragmentUrl.length > 0) {
      const pos = fragmentUrl.search('id_token=');
      if (pos > 0) {
        this.showSideBar = true;
      }
    } else {
      this.showSideBar = false;
    }
  }

}
